/* oxlint-disable no-restricted-imports */
import * as remix from "@remix-run/react";
import * as router from "react-router-dom";

/**
 * A hook wrapping useParams from Remix and react-router-dom
 * It can be used in interchangeably in a Remix or react-router-dom based SPA and work as expected
 * Means that devs don't need to worry about where an app is running and what API to use
 *
 * @returns - either Remix or react-router-dom based params for the current route
 */
const useParams = <ParamsOrKey extends string | Record<string, string | undefined> = string>() => {
  // useParams doesn't throw contrary to useLocation, useNavigate and useSearchParams
  // It returns an empty object instead, so we run both and if routerParams is empty, assume we want remixParams
  // This could be a false positive in that there's just no params for the current path
  // If that's the case, the next navigation with params will re-evaluate and return routerParams if there's any
  const routerParams = router.useParams<ParamsOrKey>();
  const remixParams = remix.useParams<ParamsOrKey>();

  if (Object.keys(routerParams).length > 0) {
    return routerParams;
  }

  return remixParams;
};

export { useParams };
